/**
 * Utility functions for generating user initials
 */

/**
 * Generate initials from user's first and last name
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name
 * @param {string} fallback - Fallback character if no names available
 * @returns {string} User initials (max 2 characters)
 */
export const getUserInitials = (firstName, lastName, fallback = 'U') => {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();
  
  if (first && last) {
    return (first.charAt(0) + last.charAt(0)).toUpperCase();
  } else if (first) {
    return first.charAt(0).toUpperCase();
  } else if (last) {
    return last.charAt(0).toUpperCase();
  }
  
  return fallback.toUpperCase();
};

/**
 * Generate a consistent background color based on user's name
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name
 * @returns {string} CSS color value
 */
export const getUserInitialsColor = (firstName, lastName) => {
  const colors = [
    '#B6862C', // Primary gold
    '#8B6914', // Darker gold
    '#D4A574', // Light gold
    '#9B7B2A', // Medium gold
    '#A68B3B', // Warm gold
    '#C19A47', // Bright gold
    '#7A5F1A', // Deep gold
    '#E6C088', // Pale gold
  ];
  
  const name = `${firstName || ''}${lastName || ''}`.toLowerCase();
  let hash = 0;
  
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  return colors[Math.abs(hash) % colors.length];
};